import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { StatusLabel } from '@components/StatusLabel'
import { formatDate, formatNumber } from '@atheneum/api/dist/lib'

class ContractsTable extends Component {
  static propTypes = {
    history: PropTypes.object,
    contracts: PropTypes.object,
    parentAccountName: PropTypes.string,
    staticData: PropTypes.object,
    sidebarStore: PropTypes.object,
    includeParentAcc: PropTypes.bool
  }

  renderTotalVolume = contract => {
    const { currencies } = this.props.staticData.names

    const totalVolume = contract.value

    return (
      <span className='text-wrapper right'>
        {contract.unlimited
          ? 'unlimited'
          : `${formatNumber(totalVolume)} ${currencies[contract.currencyId]}`}
      </span>
    )
  }

  renderBalance = contract => {
    const { currencies } = this.props.staticData.names

    const balanceClass = classNames({
      'text-wrapper': true,
      'text-wrapper--error': contract.balance < 0
    })

    return (
      <span className={balanceClass}>
        {contract.unlimited
          ? 'N/A'
          : `${formatNumber(contract.balance)} ${
              currencies[contract.currencyId]
            }`}
      </span>
    )
  }

  render () {
    const {
      contracts,
      parentAccountName,
      includeParentAcc,
      staticData
    } = this.props
    const { currencies } = staticData.names

    return (
      <table className='table-wrapper invoice-table contracts'>
        <thead>
          <tr>
            <th>Contract code</th>
            {includeParentAcc && <th>Parent account</th>}
            <th>Status</th>
            <th>Start date</th>
            <th>End date</th>
            <th className='right-align'>Total volume</th>
            <th className='center'>Associated fees</th>
            <th className='right-align'>Value consumed</th>
            <th className='right-align'>Remaning balance</th>
          </tr>
        </thead>
        {contracts.map(contract => {
          return (
            <tbody key={contract.id}>
              <tr
                className='clickable-row'
                onClick={e => {
                  e.stopPropagation()
                  this.props.sidebarStore.openSidebar({
                    template: 'contract',
                    id: contract.id
                  })
                }}
              >
                <td>
                  <span
                    className='row--link'
                    onClick={e => {
                      e.stopPropagation()
                      this.props.history.push(
                        `/client-search/parent-account/${contract.parentAccountId}/contracts/${contract.id}`
                      )
                    }}
                  >
                    {contract.contractReference}
                  </span>
                </td>
                {includeParentAcc && (
                  <td
                    className='row--link'
                    onClick={e => {
                      e.stopPropagation()
                    }}
                  >
                    <NavLink
                      to={`/client-search/parent-account/${contract.parentAccountId}`}
                    >
                      {parentAccountName}
                    </NavLink>
                  </td>
                )}
                <td>
                  <StatusLabel
                    statusId={contract.contractStatusId}
                    statusesType='contractStatuses'
                  />
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(contract.startDate)}
                  </span>
                </td>
                <td>
                  <span className='text-wrapper'>
                    {formatDate(contract.endDate)}
                  </span>
                </td>
                <td className='right-align'>
                  {this.renderTotalVolume(contract)}
                </td>
                <td className='center'>
                  <span className='text-wrapper'>{contract.feeCount}</span>
                </td>
                <td className='right-align'>
                  <span className='text-wrapper'>
                    {formatNumber(contract.consumption)}{' '}
                    {currencies[contract.currencyId]}
                  </span>
                </td>
                <td className='right-align'>{this.renderBalance(contract)}</td>
              </tr>
            </tbody>
          )
        })}
      </table>
    )
  }

  calculateTotalVolume = contract => {
    const { CONTRACT_TYPES } = this.props.staticData.CONST

    if (contract.contractTypeId === CONTRACT_TYPES.PAYG) {
      return contract.value || 0
    }

    return contract.creditAmount * contract.creditValue
  }
}

export default withRouter(
  inject('staticData', 'sidebarStore')(observer(ContractsTable))
)
